<ng-template #fieldComponent></ng-template>
<div *ngIf="description$ | async as desc">
  <small class="form-text ng-star-inserted" data-testing-id="textarea-description">
    {{ desc }}
  </small>
</div>
